const generateDefaultLoginName = (firstName, lastName) => {
  const firstNameProcessed = (firstName || 'default').trim().toLowerCase().replaceAll(/\s+/g, '.').replaceAll(/-/g, '.');
  const lastNameProcessed = (lastName || 'login').trim().toLowerCase().replaceAll(/\s+/g, '.').replaceAll(/-/g, '.');

  return `${firstNameProcessed}.${lastNameProcessed}`;
};

export { generateDefaultLoginName };
